import crud from '@/crud/index/index'
import resources from '../../resources'

import components from './components'
import methods from './methods'

export default {
  components,
  methods,

  mixins: [crud, resources],
  resourcePath: '/v1/patient/settings/covenants'
}



// WEBPACK FOOTER //
// ./src/app/settings/covenants/index/resources/index.js